import message from "./message";
import User from "@/services/api/authUser";
import moment from "moment";
import Rooms from "@/services/messaging/rooms";
import dataStore from "@/services/api/store";
import roomsSeenHub from "@/services/hubs/roomsSeen";
import Nazgul from "@/services/nazgul";

export default {
  props: ["room", "recipient", "store"],
  components: { message },
  data() {
    return {
      messages: [],
      messageContent: "",
      loading: false,
      finished: false
    };
  },
  created() {
    this._store = this.store || "CoachMessagingRooms";
    this.setLastSeen();
    this.lastScroll = 0;
    this.messagingRoom = Rooms.getRoom(this.room.id);
    this.loading = true;
    this.messagingRoom.init().then(messages => {
      this.messages = [...messages];
      setTimeout(() => {
        this.scrollBottom();
      });
      this.loading = false;
    });
    this.subscription = this.messagingRoom.messagesSub.subscribe(message => {
      this.messages.push(message);
      setTimeout(() => this.scrollBottom());
      this.setLastSeen();
    });
  },
  methods: {
    setLastSeen() {
      roomsSeenHub.update(this.room.id);
      dataStore.update(this._store, this.room.id, {
        last_seen: moment().format()
      });
    },
    sendMessage() {
      if (!this.messageContent) {
        return;
      }

      Nazgul.report("message_sent");

      let message = {
        sender_id: User.id,
        room_id: this.room.id,
        sender: {
          image: User.image,
          id: User.id,
          first_name: User.first_name,
          last_name: User.last_name,
          email: User.email
        },
        created_at: moment(),
        payload: {
          message: this.messageContent
        }
      };
      this.messagingRoom.sendMessage(message);
      this.messageContent = "";
    },
    onScroll() {
      let messageContainer = this.$el.querySelector(".messages-container");
      let currentScroll = messageContainer.scrollTop;
      if (
        !this.loading &&
        !this.messagingRoom.finished &&
        currentScroll < this.lastScroll &&
        messageContainer.scrollTop < 50
      ) {
        this.loading = true;
        this.messagingRoom
          .loadMoreMessages()
          .then(messages => {
            this.messages = messages.concat(this.messages);
            // give a little offset so the user has to scroll up to get more
            messageContainer.scrollTop = 50;
          })
          .then(() => (this.loading = false));
      }
      this.lastScroll = currentScroll;
    },
    scrollBottom() {
      let messageContainer = this.$el.querySelector(".messages-container");
      messageContainer.scrollTop = messageContainer.scrollHeight;
    }
  },
  beforeDestroy() {
    this.setLastSeen();
  },
  destroyed() {
    this.subscription.unsubscribe();
  }
};
